class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.trendingAndProductsBlock = this.querySelector('[data-quick-trending-products]');
    this.closeStickySearchButton = document.querySelector('.header-search-close');
    this.productToShow = this.dataset.productToShow;
    this.searchDetails = this.querySelector('.search_details');
    this.predictiveSearch = this.querySelector('predictive-search')
    this.isOpen = false;
    this.quickSearchTrending = this.querySelectorAll('.quickSearchTrending .link');
    this.searchResultsWidget = this.getElementsByClassName('quickSearchResultsWidget')[0];

    this.setupEventListeners();
    this.quickSearchTrending.forEach(element => {
      element.addEventListener('click', this.quickSearchTrendingClick.bind(this));
    });
  }
  
  setupEventListeners() {
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));
    
    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 500).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    document.addEventListener('click', this.onDocClick.bind(this));
    if (this.closeStickySearchButton != null) {
      this.closeStickySearchButton.addEventListener('click', this.onCloseStickySearchClick.bind(this));
    }
    this.input.addEventListener('click', this.doBeforeQuickSearchProduct.bind(this));
    if(window.innerWidth <= 1024){
        if(document.querySelector('[data-search-mobile]')){
            document.querySelectorAll('[data-search-mobile]').forEach((button) => {
                button.addEventListener('click', this.doBeforeQuickSearchProduct.bind(this));
            });
        }
    }
  }

  doBeforeQuickSearchProduct(){
    this.renderQuickSearchProductBlock();
  }

  renderQuickSearchProductBlock(){
    if(!this.searchResultsWidget.classList.contains('ajax-loaded')){
      const block = this.searchResultsWidget.querySelector('.quickSearchProduct');

      let url = block?.getAttribute('data-collection'),
          limit = block?.getAttribute('data-limit'),
          sectionId = 'list-result-block';

      if(url != null && url != undefined) {
          $.ajax({
              type: 'GET',
              url: window.routes.root + '/collections/' + url,
              cache: false,
              data: {
                  view: 'ajax_product_block',
                  constraint: `limit=${limit}+sectionId=${sectionId}`
              },
              beforeSend: () => {
                  block.closest('.quickSearchResultsWidget').classList.add('ajax-loaded');
              },
              success: (data) => {
                  if (url != '') {
                      const dataRes = this.handleResponse(data, limit);
                      block.querySelector('.products-grid').innerHTML = dataRes;
                  }
                  window.sharedFunctions?.swapHoverVideoProductCard();
              },
              complete: () => {
                  if ((window.show_multiple_currencies && Currency.currentCurrency != window.shop_currency) || window.show_auto_currency) {
                      let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                      Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                  }
              }
          });
      } else{
          this.searchResultsWidget.classList.add('ajax-loaded');
          if ((window.show_multiple_currencies && Currency.currentCurrency != window.shop_currency) || window.show_auto_currency) {
              let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
              Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
          }
      }
    }
  }

  handleResponse(data,limit) {
    let htmlMedia = document.createElement('div');
    htmlMedia.innerHTML = data;

    $(htmlMedia).find(`.product:nth-child(n+${Number(limit) + 1})`).remove();
    return $(htmlMedia).html();
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();
    
    if (!searchTerm.length) {
      this.close(true);
      return;
    }
    
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();
    
    if (!searchTerm.length) return this.showTrendingAndProducts();

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
        // this.hideTrendingAndProducts();
      };
    })
  }
  
  onKeyup(event) {
    if (!this.getQuery().length) {
      this.close(true);
      this.showTrendingAndProducts();
    };
    event.preventDefault();
    
    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';
    
    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }
    
  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }
  
  /*
   * The panel is injected inside <form class="search">, and HTML forbids nested
   * forms: the parser drops the first card's /cart/add form and re-parents its
   * hidden inputs onto the search form, so searching appended `&id=…&quantity=1`
   * to the URL (and closed the search form early). The add-to-cart controls are
   * hidden in the dropdown anyway, so strip them before inserting.
   */
  static stripCartForms(root) {
    root
      .querySelectorAll('form, input[name="id"], input[name="quantity"], button[name="add"]')
      .forEach((element) => element.remove());
  }

  /*
   * Shopify's predictive search has no typo tolerance, so when a term returns no
   * products we retry once with it corrected against the store vocabulary
   * ("gooky" -> "goosky"). Returns true when a retry was started.
   */
  retryWithCorrection(searchTerm, markup, correctedFrom) {
    if (correctedFrom || markup.includes('products-grid') || !window.HDSearchFuzzy) return false;

    const fix = window.HDSearchFuzzy.correct(searchTerm);
    if (!fix.changed) return false;

    this.getSearchResults(fix.corrected, searchTerm);
    return true;
  }

  getSearchResults(searchTerm, correctedFrom = null) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.correctedFrom = correctedFrom;
    this.correctedTerm = searchTerm;
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      if (this.retryWithCorrection(searchTerm, this.cachedResults[queryKey], correctedFrom)) return;
      this.renderSearchResults(this.cachedResults[queryKey]);
      this.updateViewAllLink(searchTerm);
      return;
    }

    /*
     * The panel comes from the search page itself (templates/search.ajax_dropdown
     * .liquid) rather than the Predictive Search API: the two rank differently and
     * predictive puts spare parts above the helicopters, which looks wrong next to
     * /search. This response also carries search.results_count, so the "view all"
     * counter needs no second request. Query suggestions still come from the
     * predictive endpoint - see loadSuggestions().
     */
    fetch(`${routes.search_url}?q=${encodeURIComponent(searchTerm)}&type=product&options%5Bprefix%5D=last&view=ajax_dropdown`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const panel = new DOMParser().parseFromString(text, 'text/html').querySelector('#predictive-search-results');
        if (panel) PredictiveSearch.stripCartForms(panel);
        const resultsMarkup = panel ? panel.outerHTML : text;
        this.cachedResults[queryKey] = resultsMarkup;

        if (this.retryWithCorrection(searchTerm, resultsMarkup, correctedFrom)) return;

        this.renderSearchResults(resultsMarkup);
        this.updateViewAllLink(searchTerm);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }
  
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
    
    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;
    
    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  /*
   * Left column: Shopify query suggestions, fetched on their own so the product
   * request keeps its full limit (see the comment in getSearchResults). Rendered
   * by sections/predictive-search-queries.liquid; the JSON endpoint is avoided
   * because it answers 401 behind `shopify theme dev`.
   */
  loadSuggestions(searchTerm) {
    const column = this.predictiveSearchResults.querySelector('[data-suggestions-col]');
    const list = this.predictiveSearchResults.querySelector('[data-suggestions-list]');
    const layout = this.predictiveSearchResults.querySelector('.predictive-search__layout');
    if (!column || !list || !searchTerm) return;

    this.cachedSuggestions = this.cachedSuggestions || {};
    const cached = this.cachedSuggestions[searchTerm];
    const request = cached
      ? Promise.resolve(cached)
      : fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=query&${encodeURIComponent('resources[limit]')}=6&section_id=predictive-search-queries`)
          .then((response) => (response.ok ? response.text() : ''))
          .then((text) => {
            this.cachedSuggestions[searchTerm] = text;
            return text;
          });

    request
      .then((text) => {
        if (!text) return;
        const items = new DOMParser().parseFromString(text, 'text/html').querySelectorAll('li');
        if (!items.length) return;

        items.forEach((item) => list.appendChild(item));
        column.hidden = false;
        if (layout) layout.classList.remove('predictive-search__layout--no-suggestions');
      })
      .catch(() => {});
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.renderCorrectionNotice();
    this.loadSuggestions(this.correctedTerm || this.getQuery());
    this.loadFallbackResults();
    this.setAttribute('results', true);
    this.setAttribute('open', true);
    this.setLiveRegionResults();
    this.open();
    this.hideTrendingAndProducts();
    if ((window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
      Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
    }
    window.sharedFunctions?.swapHoverVideoProductCard();
  }

  /*
   * Empty dropdown (not even a correction helped): load the products of the
   * closest popular search into the rescue block rendered by
   * snippets/search-popular-terms.liquid, so the visitor still sees something.
   */
  loadFallbackResults() {
    const holder = this.predictiveSearchResults.querySelector('[data-search-fallback-results]');
    if (!holder || holder.dataset.loaded || !window.HDSearchFuzzy) return;

    const term = window.HDSearchFuzzy.bestPopular(this.correctedTerm || this.getQuery());
    if (!term) return;
    holder.dataset.loaded = '1';

    fetch(`${routes.search_url}?q=${encodeURIComponent(term)}&type=product&options%5Bprefix%5D=last&view=ajax_dropdown`)
      .then((response) => (response.ok ? response.text() : ''))
      .then((text) => {
        if (!text) return;
        const grid = new DOMParser().parseFromString(text, 'text/html').querySelector('.products-grid');
        if (!grid) return;
        PredictiveSearch.stripCartForms(grid);

        holder.appendChild(window.HDSearchFuzzy.headingFor(term));
        holder.appendChild(grid);

        if (window.sharedFunctions?.swapHoverVideoProductCard) {
          window.sharedFunctions.swapHoverVideoProductCard();
        }
      })
      .catch(() => {
        holder.dataset.loaded = '';
      });
  }

  // "No results for "gooky". Showing results for "goosky"." above the columns.
  renderCorrectionNotice() {
    if (!this.correctedFrom || !window.HDSearchFuzzy) return;
    // Only worth saying when the correction actually produced products.
    if (!this.predictiveSearchResults.querySelector('.products-grid')) return;

    const container = this.predictiveSearchResults.querySelector('#predictive-search-results .container');
    if (!container || container.querySelector('.hd-search-corrected')) return;

    container.insertBefore(
      window.HDSearchFuzzy.noticeHtml(this.correctedFrom, this.correctedTerm),
      container.firstChild
    );
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }
  
  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector('[class^="header-navigation"]').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }
  
  /*
   * The panel needs more room than the search bar itself to fit the suggestions
   * column plus four readable cards, so widen it up to PANEL_MAX_WIDTH when there
   * is space. Measured rather than hardcoded in CSS, because the bar's offset
   * changes with the header layout and viewport - this can never overflow.
   */
  sizePanel() {
    const wrap = this.predictiveSearchResults;
    if (!wrap) return;

    if (window.innerWidth <= 1024) {
      wrap.style.removeProperty('width');
      return;
    }

    const PANEL_MAX_WIDTH = 1240;
    const GUTTER = 20;
    const rect = this.getBoundingClientRect();
    const styles = window.getComputedStyle(wrap);
    // Some headers anchor the panel to the right of the bar instead of the left.
    const anchoredRight = styles.left === 'auto' && styles.right !== 'auto';
    const available = anchoredRight
      ? rect.right - GUTTER
      : window.innerWidth - rect.left - GUTTER;

    const width = Math.max(rect.width, Math.min(PANEL_MAX_WIDTH, available));
    wrap.style.width = `${Math.round(width)}px`;
  }

  open() {
    //this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.sizePanel();
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');

    this.isOpen = false;
  }

  showTrendingAndProducts() {
    if (!this.trendingAndProductsBlock) return 
    this.trendingAndProductsBlock.classList.add('is-show')
    this.trendingAndProductsBlock.classList.remove('hidden');
  }

  hideTrendingAndProducts() {
    if (!this.trendingAndProductsBlock) return 

    this.trendingAndProductsBlock.classList.remove('is-show')
    this.trendingAndProductsBlock.classList.add('hidden');
  }

  onDocClick(e) {
    const isInModal = this.contains(e.target), $target = e.target

    if (!isInModal || $target.closest('.header-search-popup-close') || $target.matches('.header-search-popup-close') || $target.closest('.header-search-close') || $target.matches('.header-search-close')) {
      this.close();
      this.hideTrendingAndProducts();
    }
  }

  onCloseStickySearchClick() {
    this.close();
    this.hideTrendingAndProducts();
    document.querySelector('body').classList.remove('sticky-search-open');
    document.querySelector('body').classList.remove('sticky-search-menu-open');
    this.closest('[class*="section-header-"]')?.classList.remove('sticky-search-menu-open')
    this.closest('[class*="section-header-"]')?.classList.remove('sticky-search-menu-custom-open')
  }

  /*
   * The count is already in the panel (search.results_count), so this only has to
   * keep the href right - and carry the typo across, so the search page shows the
   * same "showing results for" notice.
   */
  updateViewAllLink(searchTerm) {
    const qsViewAllLink = document.querySelector('[data-qs-view-all-link]');
    if (!qsViewAllLink) return;

    let linkTotal = `${routes.search_url}?q=${encodeURIComponent(searchTerm)}&options%5Bprefix%5D=last&type=product`;
    if (this.correctedFrom) linkTotal += `&hd_from=${encodeURIComponent(this.correctedFrom)}`;

    qsViewAllLink.href = linkTotal;
  }

  quickSearchTrendingClick(event) {
    window.location = event.currentTarget.getAttribute('href');
  }
}

customElements.define('predictive-search', PredictiveSearch);
